module.exports = __webpack_public_path__ + "img/splash.f0755a61.gif";